import {
  PT_PRODUCT_LIST,
  PT_PRODUCT,
} from "../../../../routes/stack/paths/pt-home";
import {
  set_dto_selected_merchant_or_product,
  set_dto_Merchant,
} from "../../../../classes/dto-setters/dto-setter";
import { GET_SELECTED_MERCHANT_OR_PRODCUCT } from "../../../../database/get-stored-data";
import { dto_selected_merchant_or_product } from "../../../../classes/dto-selected-merchant-or-product";
import { api_LoadMerchantForMID } from "../../../../connection/api/api-home";
import { Api_DrawAnalyticalPath } from "../../../../connection/api/api-Machine-Learning";
import { dto_MobileAppCategory } from "../../../../classes/dto-mobile-app-category";
import { F_Fammily, Font } from "../../../../util/config-fonts";
import { KEY_GENERATOR } from "../../../../functions/funtion";
import { dto_Merchant } from "../../../../classes/dto-merchant";
import { dto_common } from "../../../../classes/dto-common";
import { Container } from "react-bootstrap";
import { Colors } from "../../../../util/colors";
import HorizontalProductSecion from "./horizontal-product";
import React from "react";

export default class ViewProdutSection extends React.PureComponent {
  render() {
    return (
      <Container
        style={{
          overflowY: "hidden",
          paddingTop: 5,
          width: "100%",
        }}
        className="fadeInUp animated"
        data-wow-duration="300ms"
        data-wow-delay="0ms"
      >
        {/* NO SCROLL - Fixed header */}
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            marginTop: 5,
            marginBottom: 0,
            padding: "0px 10px",
            flexShrink: 0,
          }}
        >
          <div
            style={{
              alignContent: "flex-start",
              textAlign: "left",
              fontSize: Font.MainHeading,
              fontFamily: F_Fammily.Medium,
              color: Colors.ThemeBGcolor,
            }}
          >
            {this.props.Name.trim()}
          </div>

          <div
            style={{
              fontSize: 13,
              fontWeight: "bold",
              display: this.props.pmData.length > 3 ? "block" : "none",
            }}
             onClick={async () => {
              let rs = await GET_SELECTED_MERCHANT_OR_PRODCUCT();
              if (rs) {
                rs.CATID = this.props.pmData[0].CI;
                dto_Merchant.MID = this.props.pmData[0].MID;
                await set_dto_selected_merchant_or_product(rs);
              } else {
                let data = await api_LoadMerchantForMID(
                  dto_common.DineType,
                  this.props.pmData[0].MID
                );
                let objData = JSON.parse(data);
                let MerchantInfo = JSON.parse(objData.MerchantInfo);
                let selectedMerchant = MerchantInfo[0];
                await set_dto_Merchant(selectedMerchant);
                await set_dto_selected_merchant_or_product(selectedMerchant);
              }
              dto_selected_merchant_or_product.MobileAppUIType = 2;
              dto_MobileAppCategory.MACID = 1;
              dto_selected_merchant_or_product.CATID = this.props.pmData[0].CI;
              dto_MobileAppCategory.ListType = 2;
              this.props.navigate(
                PT_PRODUCT_LIST.replace(":navPage", "shome").replace(
                  ":isSec",
                  "true"
                )
              );
            }}
          >
            More
            <i className="bi bi-chevron-right" style={{ marginLeft: 10 }} />
          </div>
        </div>

        {/* SHOULD SCROLL - Horizontal scroll container */}
        <div
          style={{
            display: "flex",
            overflowY: "hidden",
            width: "100%",
            paddingBottom: 10,
          }}
        >
          {this.props.pmData.slice(0, 10).map((rs) => {
            return (
              <HorizontalProductSecion
                data={rs}
                key={KEY_GENERATOR()}
                ItemClick={async (rs) => {
                  await this.selected_product(rs);
                }}
              />
            );
          })}
        </div>
      </Container>
    );
  }

  async selected_product(data) {
    await Api_DrawAnalyticalPath(1, data.PI);
    await set_dto_selected_merchant_or_product(data);
    this.props.navigate(
      PT_PRODUCT.replace(":frompage", "section-product")
        .replace(":navigatepage", "home")
        .replace(":category", "category")
        .replace(":pid", data.PI)
        .replace(":lineid", 1)
        .replace(":adonlineid", 1)
        .replace(":isrecommended", 0)
    );
  }
}
